import { useEffect } from 'react';
import clinic from '@/data/clinic';

/* Dependency-free document-head manager.
   Updates <title>, meta description, canonical, Open Graph / Twitter tags and
   injects per-route JSON-LD. Googlebot renders this; static per-route meta for
   non-JS crawlers/social is also generated at build time by scripts/prerender.js. */

function upsertMeta(key, attr, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function absUrl(path) {
  if (!path) return clinic.siteUrl + '/';
  if (/^https?:\/\//.test(path)) return path;
  return clinic.siteUrl + (path.startsWith('/') ? path : '/' + path);
}

export default function Seo({ title, description, path, image, jsonLd, noindex }) {
  const jsonKey = jsonLd ? JSON.stringify(jsonLd) : '';
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta('description', 'name', description);

    const url = absUrl(path);
    upsertLink('canonical', url);
    upsertMeta('og:url', 'property', url);
    if (title) {
      upsertMeta('og:title', 'property', title);
      upsertMeta('twitter:title', 'name', title);
    }
    if (description) {
      upsertMeta('og:description', 'property', description);
      upsertMeta('twitter:description', 'name', description);
    }

    const img = absUrl(image || '/og-image.jpg');
    upsertMeta('og:image', 'property', img);
    upsertMeta('twitter:image', 'name', img);
    upsertMeta('robots', 'name', noindex ? 'noindex, nofollow' : 'index, follow');

    document.querySelectorAll('script[data-seo="route"]').forEach((s) => s.remove());
    const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
    blocks.forEach((obj) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.setAttribute('data-seo', 'route');
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, path, image, noindex, jsonKey]);

  return null;
}
